export default {
  HEADING: 'Willkommen bei arztpool - Jetzt einloggen!',
  CLOSE: 'Schließen',
  FORM: {
    MAIL: 'E-Mail',
    PASSWORD: 'Passwort',
    PASSWORD_SHOW: 'Passwort anzeigen',
    PASSWORD_HIDE: 'Passwort verbergen',
    REMAIN_SIGNUP: 'Eingeloggt bleiben',
    SUBMIT: 'LOGIN',
  },
  RESET_PASSWORD: 'Passwort vergessen?',
  ERROR: {
    INCORRECT_USERNAME_OR_PASSWORD: 'E-Mail oder Passwort nicht korrekt.',
    USER_IS_NOT_CONFIRMED: 'Dieses Nutzerkonto wurde noch nicht bestätigt.',
    PASSWORD_RESET_REQUIRED_FOR_THE_USER: 'Sie müssen Ihr Passwort ändern, um sich einzuloggen.',
  },
  FOOTER: {
    HEADING: 'Noch keinen Account?',
    REGISTERBUTTON: ' Jetzt registrieren',
    AGREEMENT: [
      'Mit Erstellung eines Accounts stimmen Sie unseren',
      'AGB',
      'und',
      'Datenschutzbestimmungen',
      'zu.',
    ],
  },
};
